import React from 'react'

export default function SitePin({className,color}) {
    return (
        <svg 
        className={`  ${className}`}   
        aria-hidden="true" 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none"
        viewBox="0 0 24 24">
            <path stroke={color||"currentColor"} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
            <path stroke={color||"currentColor"}  strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17.8 14h0a7 7 0 1 0-11.5 0h0l.1.3.3.3L12 21l5.1-6.2.6-.7.1-.2Z" />
        </svg>
    )
}
